export default __webpack_public_path__ + "static/media/business_card_portrait_2x3.5in.a2f5a994.png";